import * as Sentry from "@sentry/react";

export let checkoutSpan: ReturnType<typeof Sentry.startInactiveSpan> | undefined;

export function endCheckoutSpan() {
  checkoutSpan?.end();
  checkoutSpan = undefined;
}

export function initCheckoutSpan({ fromHandoff = false }: { fromHandoff?: boolean } = {}) {
  const startTime = fromHandoff ? performance.timeOrigin : performance.now();

  checkoutSpan = Sentry.startInactiveSpan({
    name: "checkout-flow",
    startTime: startTime / 1000,
    attributes: {
      "checkout.from_handoff": fromHandoff,
    },
  });
  Sentry.setActiveSpanInBrowser(checkoutSpan);
}

export function measurePerformance(
  name: string,
  startMark: string,
  endMark: string,
  onMeasure?: () => void
) {
  try {
    if (performance.getEntriesByName(startMark, "mark").length === 0) {
      return;
    }
    performance.mark(endMark);
    performance.measure(name, startMark, endMark);
    onMeasure?.();
    performance.clearMarks(startMark);
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        "performance.measure_error": "true",
        "performance.measure_name": name,
        "performance.measure_startMark": startMark,
        "performance.measure_endMark": endMark,
      },
    });
  }
}
